import { Input, Label } from "reactstrap";

const ConfigCheckbox = ({ label, checked, onChange, name }) => {
  return (
    <div className="form-check mb-3">
      <Input
        className="form-check-input"
        type="checkbox"
        id={name}
        defaultChecked={checked}
        onChange={onChange}
        name={name}
      />
      <Label className="form-check-label" htmlFor={name}>
        {label}
      </Label>
    </div>
  );
};

export default ConfigCheckbox;
